import firebase from 'firebase/app'
import Firestore from './initFirebase'
import { globalOnDemandVars } from '../helper/context'

function deleteAnonymousUserData () {
  const userData = globalOnDemandVars.userData()
  if (userData && userData.isAnonymous) {
    Firestore.collection('users').doc(userData.uid).delete()
    firebase.auth().currentUser.delete()
  }
}

export default deleteAnonymousUserData
